import cx from 'classnames'
import { useFormik } from 'formik'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'

import ButtonCinestar from '../../Buttons/ButtonCinestar/ButtonCinestar'
import InputPassword from '../../Inputs/InputPassword/InputPassword'
import FormLayout from '../FormLayout/FormLayout'
import FormPasswordValidation from '../FormPasswordValidation/FormPasswordValidation'

import './FormChangeForgottenPassword.scss'

const FormChangeForgottenPassword = ({ handleSubmit, handleCancel, className, email, loading }) => {
    const intl = useIntl()

    const formik = useFormik({
        initialValues: {
            password: '',
            confirmNewPassword: '',
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .matches(
                    /^((?=.*\d)(?=.*[a-z,A-Z]).{8,16}$)/,
                    intl.formatMessage({ id: 'forms.changeForgottenPassword.invalidPassword' })
                )
                .required(intl.formatMessage({ id: 'forms.required' }))
                .test(
                    'password does not match email',
                    intl.formatMessage({ id: 'forms.changeForgottenPassword.passwordMatchesEmail' }),
                    function (value) {
                        return email !== value
                    }
                ),
            confirmNewPassword: Yup.string()
                .required(intl.formatMessage({ id: 'forms.required' }))
                .test(
                    'newPasswords-match',
                    intl.formatMessage({ id: 'forms.changeForgottenPassword.passwordsMustMatch' }),
                    function (value) {
                        return this.parent.password === value
                    }
                ),
        }),
        onSubmit: (values) => handleSubmit(values),
    })

    return (
        <FormLayout
            onSubmit={formik.handleSubmit}
            className={cx('form-change-forgotten-password d-flex flex-column', className)}
        >
            <Container fluid className={'d-flex flex-column'}>
                <InputPassword
                    id={'password'}
                    name={'password'}
                    {...formik.getFieldProps('password')}
                    error={formik?.errors?.password}
                    touched={formik?.touched?.password}
                    label={intl.formatMessage({ id: 'forms.changeForgottenPassword.newPasswordLabel' })}
                    placeholder={intl.formatMessage({ id: 'forms.changeForgottenPassword.newPasswordPlaceholder' })}
                    disabled={loading}
                    onBlur={formik?.handleBlur}
                />
                <FormPasswordValidation
                    value={formik?.values?.password}
                    touched={formik?.touched?.password}
                    email={email}
                />
            </Container>
            <InputPassword
                id={'confirmNewPassword'}
                name={'confirmNewPassword'}
                {...formik.getFieldProps('confirmNewPassword')}
                error={formik?.errors?.confirmNewPassword}
                touched={formik?.touched?.confirmNewPassword}
                label={intl.formatMessage({ id: 'forms.changeForgottenPassword.confirmationPasswordLabel' })}
                placeholder={intl.formatMessage({
                    id: 'forms.changeForgottenPassword.confirmationPasswordPlaceholder',
                })}
                disabled={loading}
                onBlur={formik?.handleBlur}
            />
            <div className={'buttons-login d-flex'}>
                <ButtonCinestar variant={'primary-v1'} type={'submit'} disabled={loading}>
                    {intl.formatMessage({ id: 'forms.changeForgottenPassword.buttonChange' })}
                </ButtonCinestar>
                <ButtonCinestar variant={'secondary'} iconLeft={'cross'} onClick={handleCancel} disabled={loading}>
                    {intl.formatMessage({ id: 'forms.changeForgottenPassword.buttonCancel' })}
                </ButtonCinestar>
            </div>
        </FormLayout>
    )
}

export default FormChangeForgottenPassword
